// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import store from './store'
import axios from './axiosApis/axiosUtils'
import VueAxios from 'vue-axios'
import VueMoment from 'vue-moment'
import moment from 'moment'
import VModal from 'vue-js-modal'
import Chart from 'chart.js'
// eslint-disable-next-line no-unused-vars
import ChartDataLabels from 'chartjs-plugin-datalabels'
import browserDetect from 'vue-browser-detect-plugin'

Chart.defaults.global.plugins.datalabels.display = false
moment.locale('ko')

Vue.use(VModal, { dynamic: true })
Vue.use(VueMoment, { moment })
Vue.use(VueAxios, axios)
Vue.use(browserDetect)
Vue.config.productionTip = false

window.store = store
/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store: store,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js